<template>
    <div class="report__builder_schedule_form">
        <div class="report__builder_schedule_form_scheduler">
            <form-radio
                :label="``"
                :hint-position-top="true"
                :name="'report-builder-form-schedule-type-never'"
                :items="[
                    {
                        name: 'Never',
                        value: 'never'
                    }
                ]"
                :value="reportSchedulePeriodType === '' ? 'never' : reportSchedulePeriodType"
                @input="setSchedulePeriodType('')"
            >Schedule your report to run automatically.
            </form-radio>
            <component-wrapper>
                <div class="columns is-vcentered">
                    <div class="column is-narrow">
                        <form-radio
                            :label="''"
                            :name="'report-builder-form-schedule-daily-interval-type'"
                            :items="[
                                {
                                    name: 'Daily interval',
                                    value: 'day'
                                }
                            ]"
                            :value="reportSchedulePeriodType"
                            @input="setSchedulePeriodType"
                        ></form-radio>
                    </div>
                    <div class="column">
                        <form-number
                            :label="''"
                            :min="1"
                            :name="'report-builder-form-schedule-daily-interval-value'"
                            :disabled="reportSchedulePeriodType !== 'day'"
                            :value="reportSchedulePeriodType === 'day' ? reportScheduleInterval : 1"
                            @input="setScheduleInterval"
                        ></form-number>
                    </div>
                </div>
            </component-wrapper>
            <form-radio
                :label="''"
                :name="'report-builder-form-schedule-weekly-interval-type'"
                :items="[
                    {
                        name: 'Weekly on',
                        value: 'week'
                    }
                ]"
                :value="reportSchedulePeriodType"
                @input="setSchedulePeriodType"
            ></form-radio>
            <form-radio
                :label="''"
                :disabled="reportSchedulePeriodType !== 'week'"
                :name="'report-builder-form-schedule-weekly-interval-value'"
                :overlay="true"
                :hint-position-top="true"
                :items="[
                    {
                        name: 'Monday',
                        value: 1
                    },
                    {
                        name: 'Tuesday',
                        value: 2
                    },
                    {
                        name: 'Wednesday',
                        value: 3
                    },
                    {
                        name: 'Thursday',
                        value: 4
                    },
                    {
                        name: 'Friday',
                        value: 5
                    },
                    {
                        name: 'Saturday',
                        value: 6
                    },
                    {
                        name: 'Sunday',
                        value: 0
                    }
                ]"
                :value="reportSchedulePeriodType === 'week' ? reportScheduleInterval : ''"
                @input="setScheduleInterval"
            ></form-radio>
            <form-radio
                :label="''"
                :name="'report-builder-form-schedule-monthly-interval'"
                :items="[
                    {
                        name: 'Monthly on',
                        value: 'month'
                    }
                ]"
                :value="reportSchedulePeriodType"
                @input="setSchedulePeriodType"
            ></form-radio>
            <component-wrapper :overlay="true">
                <div class="columns is-vcentered">
                    <div class="column is-narrow">
                        <form-radio
                            :label="''"
                            :disabled="reportSchedulePeriodType !== 'month'"
                            :name="'report-builder-form-schedule-monthly-interval-selected-type'"
                            :hint-position-top="true"
                            :items="[
                                {
                                    name: 'On selected day of the month',
                                    value: 'selected'
                                }
                            ]"
                            :value="reportSchedulePeriodType === 'month' && reportScheduleInterval < 31 ? 'selected' : false"
                            @input="setScheduleInterval(1)"
                        ></form-radio>
                    </div>
                    <div class="column">
                        <form-number
                            :label="''"
                            :disabled="reportSchedulePeriodType !== 'month' || reportScheduleInterval === 31"
                            :min="1"
                            :max="30"
                            :name="'report-builder-form-schedule-monthly-interval-selected-value'"
                            :value="reportSchedulePeriodType === 'month' && reportScheduleInterval < 31 ? reportScheduleInterval : 1"
                            @input="setScheduleInterval"
                        ></form-number>
                    </div>
                </div>
                <form-radio
                    :label="''"
                    :disabled="reportSchedulePeriodType !== 'month'"
                    :name="'report-builder-form-schedule-monthly-interval-last'"
                    :hint-position-top="true"
                    :items="[
                        {
                            name: 'The last day of a month',
                            value: 'last'
                        }
                    ]"
                    :value="reportSchedulePeriodType === 'month' && reportScheduleInterval === 31 ? 'last' : false"
                    @input="setScheduleInterval(31)"
                ></form-radio>
            </component-wrapper>
            <div class="report__builder_schedule_form_scheduler_duration">
                <form-date
                    :disabled="reportSchedulePeriodType === 'never'"
                    :label="'Generate reports starting from'"
                    :name="'report-builder-form-schedule-from'"
                    :value="reportScheduleFrom"
                    :data-vv-as="'date from'"
                    :v-validate="`date_format:yyyy-MM-dd|${reportScheduleFrom && reportScheduleTo ? `before:${reportScheduleTo}` :  ``}`"
                    @input="setScheduleFrom"
                >Set a start date or leave blank to start this schedule from today.
                </form-date>
                <form-date
                    :disabled="reportSchedulePeriodType === 'never'"
                    :label="'Generate reports until'"
                    :name="'report-builder-form-schedule-to'"
                    :value="reportScheduleTo"
                    :data-vv-as="'date to'"
                    :v-validate="`date_format:yyyy-MM-dd|${reportScheduleFrom && reportScheduleTo ? `after:${reportScheduleFrom}` :  ``}`"
                    @input="setScheduleTo"
                >Set an end date or leave this blank to run this report until cancelled manually.
                </form-date>
            </div>
        </div>
        <component-wrapper class="report__builder_schedule_form_mailing">
            <div class="columns">
                <div class="column">
                    <form-text
                        :disabled="reportSchedulePeriodType === 'never'"
                        :class="'report__builder_schedule_form_mailing_recipient'"
                        :label="'Mailing list'"
                        :name="'report-builder-form-mailing-list-email'"
                        :hint-position-top="true"
                        v-model="dataRecipient"
                    >Enter recipients email address you want to send this report to.
                    </form-text>
                </div>
                <div class="column is-narrow is-align-self-bottom">
                    <component-button
                        :disabled="!dataRecipient.match(emailRegex) || reportScheduleRecipients.includes(dataRecipient)"
                        :name="'report-builder-form-mailing-list-add'"
                        @click="reportBuilderScheduleRecipientsAdd"
                    >Add recipient
                    </component-button>
                </div>
            </div>
            <component-text-button
                v-for="(email, index) in reportScheduleRecipients"
                :index="index"
                :key="index"
                :value="email"
                @click="reportBuilderScheduleRecipientsRemove(index)"
            >{{ email }}
            </component-text-button>
            <form-notification
                :disabled="reportSchedulePeriodType === 'never'"
                :class="'report__builder_schedule_form_mailing_notification'"
                :trigger-event="'ScheduledReportExecutedEvent'"
                :name="'Scheduled report generated'"
                :custom-button-active="false"
                :primary-button-text="'Save notification'"
            ></form-notification>
            <component-button
                v-if="false"
                :class="'report__builder_schedule_form_mailing_sendtest'"
                :name="'report-builder-edit-form-sendtest'"
                :align="'right'"
                :theme="'default'"
                :animate-loading="true"
                :animate-loading-event-name="'send-report-test'"
                @click="performSendTestReport"
            >Send test report to self
            </component-button>
            <form-checkbox
                :disabled="reportSchedulePeriodType === 'never'"
                :name="'report-builder-edit-form-sendoncreation'"
                :label="'Send to mailing list on creation of the report'"
                :value="reportForceReport"
                @input="setReportBuilderForceReport"
            ></form-checkbox>
        </component-wrapper>
        <template v-if="!isShowMode">
            <component-wrapper>
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-builder-form-submit'"
                            :animate-loading="true"
                            :animate-loading-event-name="'report-builder-submit'"
                            @click="performSubmitValidate"
                        >Save schedule</component-button>
                    </div>
                </div>
            </component-wrapper>
        </template>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import { performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import { toCapitalize, toISODateUTC } from '@/functions'
import { emailRegex } from '@/variables'
import { User } from '@/User'
import FormRadio from '@/components/default/forms/FormRadio'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import FormNumber from '@/components/default/forms/FormNumber'
import FormDate from '@/components/default/forms/FormDate'
import FormText from '@/components/default/forms/FormText'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentTextButton from '@/components/default/shared/ComponentTextButton'
import FormNotification from '@/components/default/forms/FormNotification'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'report-builder-form',
  components: { PopNotify, FormCheckbox, FormNotification, ComponentTextButton, ComponentButton, FormText, FormDate, FormNumber, ComponentWrapper, FormRadio },
  data () {
    return {
      requestPending: false,
      dataRecipient: '',
      emailRegex,
      user: new User()
    }
  },
  mixins: [validateBeforeRouteLeave, performSubmitValidate, watchContentChangeEmit],
  computed: {
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    reportId () {
      return this.$store.getters.getEbsReportBuilderId
    },
    reportScheduleRecipients: {
      get () {
        return this.$store.getters['getEbsReportBuilderScheduleRecipients']
      }
    },
    reportForceReport: {
      get () {
        return this.$store.getters['getEbsReportBuilderForceReport']
      }
    },
    reportSchedulePeriodType () {
      return this.$store.getters.getEbsReportBuilderScheduleIntervalPeriodType
    },
    reportScheduleInterval () {
      return this.$store.getters.getEbsReportBuilderScheduleIntervalInterval
    },
    reportScheduleFrom () {
      return this.$store.getters.getEbsReportBuilderScheduleFrom
    },
    reportScheduleTo () {
      return this.$store.getters.getEbsReportBuilderScheduleTo
    },
    routeName () {
      return this.$route.name
    },
    //
    rootItemName () {
      return 'report-builder-schedule'
    },
    nameActionCreate () {
      return 'ebsReportBuilderCreateAndExecute'
    },
    nameActionUpdate () {
      return 'ebsReportBuilderUpdateAndExecute'
    },
    paramsActionCreate () {
      return { execute: false }
    },
    paramsActionUpdate () {
      return { id: this.reportId, execute: false }
    },
    isAddMode () {
      return this.$route.name.includes('report-builder-add')
    },
    isEditMode () {
      return this.$route.name.includes('report-builder-edit')
    },
    isShowMode () {
      return this.$route.name.includes('report-builder-show')
    },
    workspaceOrgUnits () {
      return this.$store.getters.getLmsSuperadminOrgUnitsMappedIdName
    }
  },
  methods: {
    performSendTestReport () {
      this.$store.dispatch('ebsReportBuilderSendTest', this.reportId).finally(() => {
        this.$eventBus.$emit('stop-send-report-test')
      })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-report-builder-submit')
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-report-builder-submit')
    },
    reportBuilderScheduleRecipientsRemove (data) {
      this.$store.dispatch('ebsReportBuilderScheduleRecipientsRemove', data)
    },
    reportBuilderSetFilterCourseId (data) {
      this.$store.dispatch('ebsReportBuilderFiltersSetSpecific', {
        column: 'App\\Domain\\Reports\\ModuleActivity\\Nodes\\Columns\\CatalogItemId',
        type: 'equals',
        threshold: { value: data.value }
      })
    },
    reportBuilderScheduleRecipientsAdd () {
      this.$store.dispatch('ebsReportBuilderScheduleRecipientsAdd', this.dataRecipient)
      this.dataRecipient = ''
    },
    setReportBuilderForceReport (value) {
      this.$store.dispatch('ebsReportBuilderSetForceReport', value)
    },
    setSchedulePeriodType (data) {
      this.$store.dispatch('ebsReportBuilderSetScheduleIntervalPeriodType', data)
      if (data) {
        this.setScheduleInterval(1)
      } else {
        this.setScheduleInterval(0)
      }
    },
    setScheduleInterval (data) {
      this.$store.dispatch('ebsReportBuilderSetScheduleIntervalInterval', data)
    },
    setScheduleFrom (data) {
      const dateValue = new Date(data)
      const nextDayValue = new Date(dateValue.setDate(dateValue.getDate() + 1))
      const nextDayValueISO = toISODateUTC(nextDayValue)

      this.$store.dispatch('ebsReportBuilderSetScheduleFrom', data || undefined)
      if (data) {
        this.setScheduleTo(nextDayValueISO)
      }
    },
    setScheduleTo (data) {
      this.$store.dispatch('ebsReportBuilderSetScheduleTo', data || undefined)
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportbuilderform.scss";
</style>
